import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

export const fetchDepartments = createAsyncThunk(
  'departments/fetchDepartments',
  async (organizationId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/departments/${organizationId}`, authHeaders());
      return response.data.departments;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Fehler beim Abrufen der Benutzergruppen');
    }
  }
);

export const createDepartment = createAsyncThunk(
  'departments/createDepartment',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/departments`, data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Fehler beim Erstellen der Benutzergruppe');
    }
  }
);

export const updateDepartment = createAsyncThunk(
  'departments/updateDepartment',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${BASE_URL}/departments`, data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Fehler beim Aktualisieren der Benutzergruppe');
    }
  }
);

export const deleteDepartment = createAsyncThunk(
  'departments/deleteDepartment',
  async (departmentId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${BASE_URL}/departments/${departmentId}`, authHeaders());
      return { departmentId, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Fehler beim Löschen der Benutzergruppe');
    }
  }
);

export const updateDepartmentsOrder = createAsyncThunk(
  'departments/updateDepartmentsOrder',
  async (orderList, { rejectWithValue }) => {
    try {
      await axios.put(`${BASE_URL}/departments/order`, orderList, authHeaders());
      return orderList;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Fehler beim Speichern der Reihenfolge');
    }
  }
);

const departmentsSlice = createSlice({
  name: 'departments',
  initialState: {
    departments: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state) => { state.loading = true; })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.loading = false;
        state.departments = action.payload;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createDepartment.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.departments = state.departments.filter(d => d.id !== action.payload.departmentId);
      })
      .addCase(updateDepartmentsOrder.fulfilled, (state, action) => {
        const orderMap = {};
        action.payload.forEach(item => { orderMap[item.id] = item.sort_order; });
        state.departments = [...state.departments]
          .map(d => ({ ...d, sort_order: orderMap[d.id] ?? d.sort_order }))
          .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
      });
  },
});

export default departmentsSlice.reducer;
